var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bank-details-form',{ref:"bankDetailsForm",attrs:{"initialValues":_vm.values},on:{"submit":_vm.handleSubmit,"update:isInvalid":_vm.handleUpdateIsInvalid}},[(_vm.$slots.default)?_c('div',{staticClass:"actions"},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }